var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('van-empty', {
        class: [
            'x-empty',
            {
                'x-empty__centered': _vm.centeredInContent
            }
        ],
        attrs: {
            "image": _setup.emptyImage,
            "description": _setup.emptyDescription
        }
    }, [
        _vm._t("default"),
        _vm._t("image"),
        _vm._t("description")
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
